import Link from 'next/link';
import { useRouter } from 'next/router';

import Button from '@/v2/components/Button/Button';
import useTrackBuyRelatedEvent from '@/v2/domains/Subscriptions/hooks/useTrackBuyRelatedEvent.hook';
import pricingAnalyticsConstants from '@/v2/domains/Subscriptions/pages/Pricing/constants/pricingAnalyticsConstants';

interface SignUpMenuButtonProps {
  onClickButton?: () => void;
}

export default function SignUpMenuButton({
  onClickButton,
}: SignUpMenuButtonProps) {
  const router = useRouter();
  const isPricingPage = router.pathname == '/pricing';

  const trackBuyRelatedEvent = useTrackBuyRelatedEvent();

  if (isPricingPage) {
    return (
      <Button size="large" style={{ visibility: 'hidden' }}>
        Buy now
      </Button>
    );
  }

  return (
    <Link href="/pricing">
      <Button
        size="large"
        type="primary"
        block
        onClick={() => {
          trackBuyRelatedEvent({
            eventName: pricingAnalyticsConstants.buyNow,
            location: 'topbar',
          });
          onClickButton?.();
        }}
      >
        Buy now
      </Button>
    </Link>
  );
}
